<main class="kebab-list-container">
  <section class="kebab-list-item" (click)="addToFavourite()">
    <span class="icon-text">
      <lucide-icon name="heart" size="18"></lucide-icon>
      <span>Favorite</span>
    </span>
  </section>
</main>
